import { useMemo } from 'react';
import { useGetCuratedRecommendationsQuery } from '../../../__generated__/chirp/com/hubspot/academy/recommendations/rpc/curated/CuratedRecommendationsService.hooks';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import getLang from 'academy-common-lib/utils/getLang';
import { useGetUserPersonasQuery } from '../../../__generated__/chirp/com/hubspot/user/job/profiles/rpc/AppUserPersonas.hooks';
import { useUserInfo } from '../accounts/accountsQueries';
import { mapSubPersonaToPersona } from './mappings';
export const useUserPersonas = (skip = false) => {
  var _data$userPersonas2;
  const {
    data,
    loading,
    error
  } = useGetUserPersonasQuery({
    skip
  });
  const uniquePersonas = useMemo(() => {
    var _data$userPersonas;
    const personas = (data === null || data === void 0 || (_data$userPersonas = data.userPersonas) === null || _data$userPersonas === void 0 || (_data$userPersonas = _data$userPersonas.recommendedPersonas) === null || _data$userPersonas === void 0 ? void 0 : _data$userPersonas.map(persona => mapSubPersonaToPersona(persona))) || [];
    return [...new Set(personas)];
  }, [data === null || data === void 0 || (_data$userPersonas2 = data.userPersonas) === null || _data$userPersonas2 === void 0 ? void 0 : _data$userPersonas2.recommendedPersonas]);
  return {
    personas: uniquePersonas,
    loading,
    error
  };
};
export const usePersonaRecommendations = maxCards => {
  var _userInfo$user;
  const language = getLang();
  const {
    userInfo
  } = useUserInfo();
  const userId = userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.id;
  const skip = !userId;
  const {
    personas,
    loading: personasLoading,
    error: personasError
  } = useUserPersonas(skip);
  const {
    data: curatedRecommendationsData,
    loading: curatedRecommendationsLoading,
    error: curatedRecommendationsError
  } = useGetCuratedRecommendationsQuery({
    skip,
    variables: {
      language: language.toUpperCase(),
      size: maxCards || 4
    }
  });
  const curatedRecommendations = curatedRecommendationsData === null || curatedRecommendationsData === void 0 ? void 0 : curatedRecommendationsData.recommendations;
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: (curatedRecommendations === null || curatedRecommendations === void 0 ? void 0 : curatedRecommendations.map(item => ({
      id: item.entityId,
      type: item.entityType,
      language: language
    }))) || [],
    skip: !(curatedRecommendations !== null && curatedRecommendations !== void 0 && curatedRecommendations.length)
  });
  const isLoading = personasLoading || curatedRecommendationsLoading || cardModelsLoading;
  const error = personasError || curatedRecommendationsError || cardModelsError;
  return {
    personas,
    recommendations: cardModels,
    isLoading,
    error
  };
};